import React from 'react';
import Video from './assets/MasseClub/Video.mp4';
const MasseClub = () => {
  return (
    <div className="container">
      <h2>
        ✅ Proyecto: Masse Club Pamplona🌞✨       
      </h2>
      <p>
                <video controls>
          <source src={Video} type="video/mp4" />
          Tu navegador no soporta la reproducción de video.
        </video>
 <span className='highlight'>Energía solar al servicio de la experiencia: sostenibilidad en un espacio de entretenimiento moderno.</span>

<br/><br/>En Masse Club Pamplona, un nuevo establecimiento que combina gastrobar y mesas de recreación, instalamos un sistema solar fotovoltaico conectado a la red con una capacidad de 36.92 kWp, conformado por 54 paneles solares de alta eficiencia y 2 inversores multicanal con capacidad total de 35 kW.

<br/><br/>Gracias a esta tecnología, el sistema gestiona de manera segura y estable las cargas eléctricas del local —iluminación, equipos de sonido, neveras y demás electronicos  asegurando eficiencia energética incluso en horas de alta demanda.

<br/><br/>Los objetivos de este proyecto fueron:

<br/><br/>✔ Reducir los costos asociados al consumo eléctrico del establecimiento.
<br/>✔ Implementar una solución sostenible que reduzca la huella ambiental del negocio.
<br/>✔ Garantizar energía constante para iluminación, equipos comerciales y operación del gastrobar.

<br/> <br/>Hoy, Masse Club Pamplona genera su propia energía limpia, logrando un ahorro significativo en su factura eléctrica mensual y permitiendo destinar esos recursos a mejorar la experiencia de sus clientes.

<br/>Este proyecto convierte al Masse Club en un referente de innovación sostenible dentro del sector entretenimiento en la ciudad, demostrando que es posible ofrecer experiencias de alto nivel mientras se cuida el planeta.

<br/><br/><span className='highlight'>Este proyecto cuenta con el acompañamiento de IPSUM Ingeniería e Innovación, ofreciendo:</span>

<br/><br/>🔧 Soporte técnico y mantenimiento preventivo.
<br/>🔧 Monitoreo del sistema para garantizar máxima eficiencia energética.
<br/>🔧 Instalación estructural segura, diseñada para prolongar la vida útil del sistema y facilitar su mantenimiento.
<br/>🔧 Capacitación al usuario en el manejo de la aplicación de monitoreo.
<br/>🔧 Acompañamiento presencial de nuestros ingenieros durante y después de la instalación.

<br/><br/>Una decisión inteligente que une sostenibilidad, ahorro y una experiencia inolvidable para cada visitante.
      </p>
    </div>
  );
};

export default MasseClub;
